module.exports = __webpack_public_path__ + "8395272ccf609d4378a5835958128bf6.pdf";